import React from 'react';
import { Map, YMaps, Circle, Polyline, Polygon, Placemark } from 'react-yandex-maps';
import { useNavigate } from 'react-router-dom';

const CircleYandex = ({ mapData }) => {
  const navigate = useNavigate();

  if (!mapData) return null;

  const { 
    dmCircles, 
    rsCircles, 
    polylines, 
    polygons, 
    mapObjects,
    mapCenter, 
    rsLabels,
    zoom 
  } = mapData;
 
  const handleClick = (deviceId) => {
    navigate(`/device/${deviceId}`);
  };

 return (
    <YMaps>
      {/* d3e7e816-8a75-4745-a437-18206d135c2b */}
      <Map defaultState={{ center: mapCenter, zoom: zoom }} width="100%" height="100%"> 
        {/* Обводка активного устройства) */}
        {mapObjects.map((obj) => (
          <Circle
            key={obj.id}
            geometry={obj.geometry}
            options={obj.options}
          />
        ))}

        {/* Дождевальные машины */}
        {dmCircles.map((circle) => (
          <Circle
            key={circle.id}
            geometry={circle.geometry}
            options={circle.options}
            properties={circle.properties}
            modules={["geoObject.addon.hint"]}
            onClick={() => circle.clickable && handleClick(circle.properties.deviceId)}
          />
        ))}

        {/* Линии */}
        {polylines.map((line) => (
          <Polyline
            key={line.id}
            geometry={line.geometry}
            options={line.options}
          />
        ))}

         {/* Полигоны (треугольники)  */}
         {polygons.map((polygon) => (
          <Polygon
             key={polygon.id}
             geometry={[polygon.geometry]}
             options={polygon.options} 
           /> 
         ))} 

         {/* Насосные станции */}
        {rsCircles.map((circle) => (
          <Circle
            key={circle.id}
            geometry={circle.geometry}
            options={circle.options}
            properties={circle.properties}
            modules={["geoObject.addon.hint"]}
            onClick={() => circle.clickable && handleClick(circle.properties.deviceId)}
          />
        ))}

        {/* Метки с текстом "НС" */}
        {rsLabels.map((label) => (
          <Placemark
            key={label.id}
            geometry={label.geometry}
            options={label.options}
            properties={label.properties}
          />
        ))}

      </Map>
    </YMaps>
  );
};
export default CircleYandex;